import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHoldMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="m10.527 5.172-.763-.774c-.387-.392-.47-1.06-.055-1.532.861-.98 2.102-1.607 3.49-1.607 1.39 0 2.63.626 3.492 1.607.415.473.332 1.14-.055 1.532l-.763.774c1.082.56 2.035 1.442 2.809 2.531 1.213 1.708 2.026 3.97 2.266 6.476.31-.062.634-.057.949.022 1.65.412 2.192 2.485.956 3.653l-4.555 4.302a4.374 4.374 0 0 1-3.003 1.194H2.2a.75.75 0 0 1 0-1.5h13.095c.734 0 1.44-.28 1.973-.785l4.555-4.302a.652.652 0 0 0-.846-.991l-4.3 3.308a1.75 1.75 0 0 1-1.067.363h-5.16a.75.75 0 0 1 0-1.5h4.055a.767.767 0 0 1 .05-.079.99.99 0 0 0-.806-1.564H8.166a2.362 2.362 0 0 0-2.292 1.789 1.787 1.787 0 0 1-1.734 1.354H2.2a.75.75 0 0 1 0-1.5h1.94c.132 0 .247-.09.279-.218a3.853 3.853 0 0 1 .993-1.77.75.75 0 0 1-.033-.222c0-3.022.825-5.792 2.2-7.827.797-1.183 1.8-2.14 2.948-2.734Zm1.56-.554a5.625 5.625 0 0 1 2.226 0l1.002-1.017A3.106 3.106 0 0 0 13.2 2.76c-.802 0-1.542.313-2.116.842l1.003 1.017Zm4.145 12.912 3.272-2.518c-.123-2.563-.899-4.826-2.045-6.44-1.174-1.652-2.684-2.565-4.259-2.565-1.628 0-3.19.978-4.378 2.738-1.082 1.602-1.807 3.798-1.926 6.27.4-.14.828-.215 1.27-.215h5.583c1.558 0 2.614 1.355 2.483 2.73Z"
    />
    <path
      fill="#F7A600"
      d="m10.573 10.874 1.714-.677.677-1.7a.313.313 0 0 1 .288-.202.35.35 0 0 1 .303.202l.677 1.7 1.7.677a.35.35 0 0 1 .201.302.35.35 0 0 1-.201.303l-1.7.677-.677 1.714a.364.364 0 0 1-.303.187.35.35 0 0 1-.302-.202l-.677-1.714-1.714-.677a.323.323 0 0 1-.188-.288.35.35 0 0 1 .202-.302ZM20.684 1.8l.052.312a2.372 2.372 0 0 0 1.875 1.936 2.372 2.372 0 0 0-1.875 1.936l-.052.312-.05-.298a2.396 2.396 0 0 0-1.876-1.95 2.372 2.372 0 0 0 1.874-1.936l.052-.312Z"
    />
  </svg>
);
export default SvgTwoColorHoldMoney;
